/* eslint-disable react/react-in-jsx-scope */
import { useAuth } from "@/auth/hooks/useAuth";
import { LoadingSpinner } from "@/components/ui/loadingSpinner";
import { Skeleton } from "@/components/ui/skeleton";
import { Switch } from "@/components/ui/switch";
import usePostData from "@/hooks/usePostData";
import { AppWindow, ChevronDown, Mail } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const Notification = () => {
  const { t } = useTranslation("dashboard", {
    keyPrefix: "notification",
  });
  const { user } = useAuth();
  const [active, setActive] = useState("perf");
  const { postData } = usePostData<any>();

  const [values, setValues] = useState({
    perf: { push: true, email: true },
    project: { push: true, email: true },
  });

  const notifs = [
    {
      code: "perf",
      title: t("Suivi performance"),
      description: t(
        "Il s'agit de notification de rappel sur les retards de saisi de valeur."
      ),
    },
    {
      code: "project",
      title: t("Projet"),
      description: t(
        "Il s'agit de notification sur la validation des projets."
      ),
    },
  ];

  useEffect(() => {
    if (user) {
      const m = user?.parameterCustoms?.find((p) => p.name === "notification");
      if (m) {
        setValues(JSON.parse(m.value));
      }
    }
  }, [user]);

  useEffect(() => {
    if (user && values) {
      postData({
        url: `${import.meta.env.VITE_API_ENDPOINT}/parameter/save`,
        data: {
          user: user?.id,
          project: null,
          name: "notification",
          value: JSON.stringify(values),
        },
      }).then((r) => console.log(r));
    }
  }, [values]);

  if (!user) {
    return (
      <div className="my-4">
        <h1 className="mr-5 inline align-sub text-2xl font-medium">
          {t("Paramètres de notifications")}
        </h1>{" "}
        <p className="">
          {t(
            "Verdeo est susceptible de continuer à vous envoyer des notifications importantes."
          )}
        </p>
        <div className="mt-5 text-lg">
          {t("Les notifications que vous recevez")}
        </div>
        <div className="flex flex-col gap-x-4 gap-y-14 mt-2 w-[60%]">
          <Skeleton className="w-[700px] h-16" />
          <Skeleton className="w-[700px] h-16" />
        </div>
      </div>
    );
  }

  return (
    <div className="my-4">
      <h1 className="mr-5 inline align-sub text-2xl font-medium">
        {t("Paramètres de notifications")}
      </h1>{" "}
      <p className="">
        {t(
          "Verdeo est susceptible de continuer à vous envoyer des notifications importantes."
        )}
      </p>
      <div className="mt-5 text-lg">
        {t("Les notifications que vous recevez")}
      </div>
      <div className="list-notifications mt-2 w-[60%]">
        {notifs.map((n, k) => (
          <div className="item" key={k}>
            <h2
              className="p-4 rounded-sm bg-[#00000009] text-[16px] font-medium flex justify-between cursor-pointer"
              onClick={() => setActive(n.code)}
            >
              {n.title}
              <ChevronDown />
            </h2>
            <div
              className={
                "content mb-4" +
                (active === n.code ? "" : " h-0 overflow-hidden")
              }
            >
              <p className="text-[14px] p-4">{n.description}</p>
              <div className="flex justify-between px-4 font-bold mb-4">
                <div className="flex gap-2 items-center">
                  <AppWindow size={18} />
                  {t("Push")}
                </div>
                <Switch
                  id={n.title + "push"}
                  name={n.title + "push"}
                  onCheckedChange={(value: boolean) => {
                    setValues({
                      ...values,
                      [n.code]: { ...values[n.code], push: value },
                    });
                  }}
                  value={n.code + "push"}
                  checked={values[n.code].push}
                />
              </div>
              <div className="flex justify-between px-4 font-bold">
                <div className="flex gap-2 items-center">
                  <Mail size={18} />
                  {t("Email")}
                </div>
                <Switch
                  id={n.title + "push"}
                  name={n.title + "push"}
                  onCheckedChange={(value: boolean) => {
                    setValues({
                      ...values,
                      [n.code]: { ...values[n.code], email: value },
                    });
                  }}
                  value={n.code + "push"}
                  checked={values[n.code].email}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Notification;
